import { IAppRecommendData } from '@umu/umu-types';
import {
    searchHistory,
    searchAssociativeWordsCourse,
    searchRecommendCourse,
    searchHotCourse,
    searchHistoryCourse,
} from '@umu/umu-api';
import { IParam } from '@umu/umu-api/src/services/search/searchRecommend';
import { SearchRange } from '@umu/umu-search/src/searchInputForContent/common/interface';

export const paramsData = {
    page: 1,
    size: 20,
};

export const paramsHotData = {
    page: 1,
    size: 5,
};
export const paramsHisData = {
    page: 1,
    size: 3,
};

export const getSearchData = async (keyword: string) => {
    if (!keyword) {
        return [];
    }

    const result = await searchAssociativeWordsCourse({ keyword, page: 1, size: 8 });
    return result?.list || [];
};

export const getMicroPageSearchData = async (_params: {
    keyword: string;
    searchRange: string;
    micro_page_id?: string;
}) => {
    const { keyword, searchRange, micro_page_id } = _params;

    if (!keyword) {
        return [];
    }

    const params: IParam = {
        page: 1,
        size: 8,
        keyword,
    };

    if (searchRange === SearchRange.currentPage) {
        params.micro_page_id = micro_page_id || '';
    }

    const result = await searchAssociativeWordsCourse(params);
    return result?.list || [];
};

export const getRecommandData = async (): Promise<IAppRecommendData> => {
    const historyData = await searchHistory(paramsData);
    const searchRecommendData = await searchRecommendCourse(paramsData);
    const searchHotData = await searchHotCourse(paramsHotData);
    const historyCourseData = await searchHistoryCourse(paramsHisData);

    const { list = [] } = searchRecommendData;
    const popular: IAppPopular[] = [];
    for (let i = 0; i < list.length; i++) {
        popular.push(Object.assign({}, list[i], { type: 'recomd', num: i }));
    }
    for (let j = 0; j < searchHotData.list.length; j++) {
        popular.push(Object.assign({}, searchHotData.list[j], { num: j + 1, type: 'hotCourse' }));
    }
    const recommendData = {
        historySearch: historyData.list || [],
        popular: popular || [],
        historyCourse: historyCourseData.list || [],
        LenovoCourse: [],
    };

    return recommendData as unknown as IAppRecommendData;
};

export const getUseRecommandData = async (): Promise<IAppRecommendData> => {
    const historyData = await searchHistory(paramsData);

    const recommendData = {
        historySearch: historyData.list || [],
        popular: [],
        historyCourse: [],
        LenovoCourse: [],
    };

    return recommendData as unknown as IAppRecommendData;
};
